import { render, staticRenderFns } from "./payment-edit.vue?vue&type=template&id=2397848c&scoped=true&"
import script from "./payment-edit.vue?vue&type=script&lang=js&"
export * from "./payment-edit.vue?vue&type=script&lang=js&"
import style0 from "./payment-edit.vue?vue&type=style&index=0&id=2397848c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397848c",
  null
  
)

export default component.exports